import React, { useEffect, useRef, useState } from "react";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";

import { useAppSelector } from "../../../hooks/hooks";
import { ModalCrearContacto } from "./ModalCrearContacto";
import Swal from "sweetalert2";
import { ChatSelect } from "./ChatRoom";
import { useNavigate } from "react-router-dom";

interface cliente {
    id: string;
    nombre: string;
    apellido: string;
    correo: string;
    celular: string;
    avatar: string;
}

interface crm {
    id: string;
    id_cliente: string;
    proceso: string;
    id_chat_whatsapp: string;
    usuario: cliente;
}

interface Props {
    chatSelect: ChatSelect;
}

const AditionalChatroomCrm = ({ chatSelect }: Props) => {
    const casa = useAppSelector((state) => state.landing_house.house);
    const corredor = useAppSelector((state) => state.corredor);
    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );

    const navigate = useNavigate();
    const id_chat_whatsapp = chatSelect.chatId;
    const [clientes, setClientes] = useState<cliente[]>([]);
    const [modalContacto, setModalContato] = useState<boolean>(false);
    const [count, setCount] = useState(0);

    const [proceso, setProceso] = useState("Primer seguimiento");

    const [cliente, setCliente] = useState<cliente | null>(null);
    const [crm, setCrm] = useState<crm>({
        id: "",
        id_cliente: "",
        proceso: "",
        id_chat_whatsapp: "",
        usuario: {
            id: "",
            nombre: "",
            apellido: "",
            correo: "",
            celular: "",
            avatar: "",
        },
    });

    useEffect(() => {
        getClientes();
    }, []);

    const getClientes = async () => {
        const response = await fetchAxiosToken({
            url: `/clientes/getContacts/Cliente?cliente=`,
        });

        setClientes(response);
    };

    useEffect(() => {
        getCrm();
    }, [chatSelect]);

    const getCrm = async () => {
        let id_casa = 0;
        let id_corredor = 0;
        if (tipo_usuario === 3 || tipo_usuario === 8) {
            id_casa = casa.id;
        }

        if (tipo_usuario === 6) {
            id_corredor = corredor.id;
        }
        const response = await fetchAxiosToken({
            url: `/crm/getOneByWhatsapp/${id_chat_whatsapp}/${id_casa}/${id_corredor}`,
        });
        setCount(response.count);
        setCrm(response.data);
    };

    const handleSelecteCliente = (e: any) => {
        const selected = clientes.find(
            (c) => Number(c.id) === Number(e.target.value)
        );

        if (selected) {
            setCliente(selected);
        } else {
            setCliente(null); // fallback si no se encuentra
        }
    };

    const handleGuardarCrm = async () => {
        const body = {
            id_cliente: cliente?.id,
            proceso,
            id_chat_whatsapp,
        };
        const response = await fetchAxiosToken({
            url: `/crm/postCrmFromWhatsapp`,
            method: "post",
            body,
        });
        getCrm();
        Swal.fire({
            confirmButtonColor: "#029BFC",
            iconColor: "#029BFC",
            position: "top-end",
            icon: "success",
            title: "CRM creado correctamente!",
            showConfirmButton: false,
            timer: 1500,
        });
    };

    return (
        <div className="w-full">
            <ModalCrearContacto
                modalVisibleUsuario={modalContacto}
                setModalVisibleUsuario={setModalContato}
                setClientes={setClientes}
                setCliente={setCliente}
            />

            {chatSelect?.chatId === "" ? (
                <div>Chat no seleccionado</div>
            ) : count > 0 && crm ? (
                <div className="flex flex-col justify-center items-start w-11/12 mx-auto p-2 mt-5 border-2 rounded-lg border-blue-500">
                    <div className="font-semibold text-lg ">Crm: </div>
                    <div className="text-base mt-2"> {crm.proceso} </div>

                    <div className="font-semibold text-lg mt-5">Cliente: </div>
                    <div className="text-base mt-2 flex justify-center items-center gap-3">
                        <img
                            src={
                                `${process.env.REACT_APP_PROXY}/usuarios/getImage/` +
                                crm.usuario?.avatar
                            }
                            alt="icono"
                            className="object-cover w-10 h-10 rounded-full"
                        />
                        {crm.usuario.nombre} {crm.usuario.apellido}{" "}
                    </div>
                    <div
                        onClick={() =>
                            navigate(`/dashboard-corredor/crm/${crm.id}`)
                        }
                        className="mt-5 hover:scale-105 w-full bg-blue-500 text-white p-3 rounded-lg cursor-pointer text-center font-semibold"
                    >
                        Ir al crm
                    </div>
                </div>
            ) : (
                <div className="flex flex-col justify-center items-start w-11/12 mx-auto">
                    <div className="font-semibold text-lg mt-5">Cliente: </div>
                    <div className="flex justify-center items-center gap-2 w-full mt-2">
                        <select
                            className="p-1.5 border border-blue-500 rounded-lg w-4/5"
                            value={cliente ? cliente.id : ""}
                            onChange={(e) => handleSelecteCliente(e)}
                        >
                            <option value="" disabled>
                                Selecciona un cliente
                            </option>
                            {clientes.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.nombre} {c.apellido}
                                </option>
                            ))}
                        </select>

                        <div
                            onClick={() => setModalContato(true)}
                            className="text-white text-base rounded-lg p-1 cursor-pointer bg-[#029BFC] w-1/5 text-center "
                        >
                            +
                        </div>
                    </div>
                    <div className="font-semibold text-lg mt-5">Proceso: </div>
                    <div className="flex justify-center items-center w-full ">
                        <select
                            value={proceso}
                            onChange={(e) => setProceso(e.target.value)}
                            className="p-1.5 border rounded-lg border-blue-500 w-full mt-2"
                        >
                            <option value="Primer seguimiento">
                                Primer seguimiento
                            </option>
                            <option value="Segundo seguimiento">
                                Segundo seguimiento
                            </option>
                            <option value="Propuesta enviada">
                                Propuesta enviada
                            </option>
                            <option value="Negociación">Negociación</option>
                            <option value="Ganados">Ganados</option>
                            <option value="Perdidos">Perdidos</option>
                            <option value="Seguimiento a futuro">
                                Seguimiento a futuro
                            </option>
                        </select>
                    </div>

                    <div
                        onClick={() => handleGuardarCrm()}
                        className="w-full p-1.5 text-white bg-[#029BFC] rounded-lg cursor-pointer hover:scale-105 text-center mt-5 "
                    >
                        Guardar
                    </div>
                </div>
            )}
        </div>
    );
};

export default AditionalChatroomCrm;
